import axios from "axios";
import API_BASE_URL from '../../config';

export const SetProgressUserTopicContent = async (token, idUser, content_topic_id) => {
  try {
    if (!token) {
      throw new Error("No token available");
    }

    const dataSend = {
        user_id: idUser,
        content_topic_id: content_topic_id
    }

    const responseUserFavorites = await axios.post(`${ API_BASE_URL }api/set-progress-user-topic-content/`, dataSend,
        {
          headers: {
              Authorization: `Bearer ${token}`,
          }
        }
    )
  
      return responseUserFavorites.data;

    } catch (error) {
      console.error('Error en la solicitud:', error.response ? error.response.data : error.message);
      throw error;
    }
};